// extracted by mini-css-extract-plugin
export var section = "styles-module--section--Wz2Wu";
export var container = "styles-module--container--3bV3y";
export var title = "styles-module--title--wWkXy";